import React, { Component } from 'react';

import { Helmet } from 'react-helmet';

import { Box, Typography } from '@mui/material';

import { dateNowUtc, formatDateISO } from '~/services/TimeService';

import { getOrder } from '../../../services/OrdersService';
import ReservationService from '../../../services/ReservationService';
import Payment from '../../Common/Payment';

class OrderPaymentSurcharge extends Component {
  handleOrder = async (
    cart: App.Cart,
    _offerSource: string,
    _brand: App.Brands,
    _insuranceState: App.InsuranceState,
  ) => {
    const { offers, customer, orderId, transactionKey } = cart;

    const promises = [];

    offers.forEach((offer: App.CartOffer) =>
      offer.items.forEach((item: App.CartItem) => {
        const data = {
          customer_email: customer.email,
          customer_id: customer.memberId,
          transaction_key: transactionKey,
          check_in: formatDateISO(dateNowUtc(item.reservation.checkIn)),
          check_out: formatDateISO(dateNowUtc(item.reservation.checkOut)),
          number_of_adults: item.reservation.numAdults,
          number_of_children: item.reservation.numChildren,
          number_of_infants: item.reservation.numInfants || 0,
          guest_first_name: item.reservation.firstname,
          guest_last_name: item.reservation.lastname,
          guest_special_requests: item.reservation.guestSpecialRequests,
          is_surcharge_waived: !!item.reservation.waivedSurchargeAmount,
          peak_period_surcharge: item.reservation.durationSurchargeTotal,
          extra_guest_surcharge: item.reservation.extraGuestSurcharge,
        };

        promises.push(ReservationService.createReservation(data, orderId, item.id));
      }),
    );

    await Promise.all(promises);

    const orderResponse = await getOrder(orderId);
    return orderResponse.result;
  };

  render() {
    return (
      <Box className="container">
        <Helmet>
          <title>Orders | Order surcharge payment</title>
        </Helmet>
        <Typography variant="h1">Order surcharge payment</Typography>
        <Payment
          handleOrder={this.handleOrder}
          dataPlaceholder={<Box component="div">Loading...</Box>}
          heading="Order surcharge payment"
        />
      </Box>
    );
  }
}

export default OrderPaymentSurcharge;
